import { createAtomObserver } from '@exodus/atoms'

const createApyRatesPlugin = ({ port, apyRatesAtom, apyRatesMonitor }) => {
  const apyRatesAtomObserver = createAtomObserver({ port, atom: apyRatesAtom, event: 'apyRates' })

  apyRatesAtomObserver.register()

  const onLoad = () => {
    apyRatesAtomObserver.start()
  }

  const onUnlock = () => {
    apyRatesMonitor.start()
  }

  const onStop = () => {
    apyRatesAtomObserver.unregister()
    apyRatesMonitor.stop()
  }

  return {
    onLoad,
    onUnlock,
    onStop,
  }
}

const apyRatesPluginDefinition = {
  id: 'apyRatesPlugin',
  type: 'plugin',
  factory: createApyRatesPlugin,
  dependencies: ['port', 'apyRatesAtom', 'apyRatesMonitor'],
  public: true,
}

export default apyRatesPluginDefinition
